import {ReactNode, RefObject, useRef} from 'react';
import {useScrollStickyToBottom} from '../../../common/hook/useScrollStickyToBottom';
import {MOBILE_LAYOUT_GNB_ID} from '../../../design-system/layout/constant';
import {DAY_OF_WEEK_COLUMN_TITLE_ID} from '../constant';

interface Props {
  isMobile?: boolean;
  children: (ref: RefObject<HTMLDivElement>) => ReactNode;
}

export const DayOfWeekColumnScrollHeadless = ({isMobile, children}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const columnTitleRef = useRef<HTMLElement>(null);
  const headerGnbRef = useRef<HTMLElement>(null);

  useScrollStickyToBottom({
    stickyRef: ref,
    getStickyTop: stickyInfo => {
      const {stickyHeight, rootHeight} = stickyInfo;

      if (isMobile) {
        // Mobile
        if (!headerGnbRef.current) {
          (headerGnbRef as any).current =
            document.getElementById(MOBILE_LAYOUT_GNB_ID);
        }

        const headerGnbEl = headerGnbRef.current;
        if (rootHeight >= stickyHeight && headerGnbEl) {
          return headerGnbEl.offsetHeight;
        }
      } else {
        // PC
        if (!columnTitleRef.current) {
          (columnTitleRef as any).current = document.getElementById(
            DAY_OF_WEEK_COLUMN_TITLE_ID
          );
        }

        const columnTitleEl = columnTitleRef.current;
        const {bottom = 0} = columnTitleEl?.getBoundingClientRect() ?? {};
        // 실제 화면에 보이는 컬럼 높이와 컬럼 타이틀 아래를 기준으로 컬럼 높이가 낮은 경우 컬럼 타이틀 아래를 기준으로 스티키 위치를 계산합니다.
        const height = rootHeight - bottom;
        if (height > stickyHeight) {
          return bottom;
        }
      }
    },
  });

  return <>{children(ref)}</>;
};
